import { Domain } from './domain';

export interface OwiMdr {
  readonly mdrNum: string;
  readonly libelle: string;
  readonly contenu: string;
  readonly typeLien: string;
  readonly lien: string;
  readonly texteLien: string;
  readonly attachments: OwiAttachment[];
}

export interface OwiResponse {
  readonly libelle: string;
  readonly contenu: string;
  readonly listeMdr: OwiMdr[];
  readonly listDdo: Domain[];
}

export interface OwiAttachment {
  readonly mdrNum: string;
  readonly name: string;
  readonly content: string;
}

export enum LinkTypeEnumeration {
  NO_LINK = 'U',
  DOWNLOAD = 'F',
  REDIRECTION = 'R',
  NEW_PAGE = 'N',
}
